import { useQuery } from '@tanstack/react-query';
import { API_TICKETING_TICKET_MEMBERSHIP } from 'constants/appConstants';
import axios from 'constants/axios';
import { exceptionHandler } from 'common/http-exception';
import { getTicketPermissionKeys } from './queryKeys';
import type { Membership } from './useGetTicketingBoardMembership/types';

interface TicketMembershipResponse {
  result: Membership;
  error?: {
    code: string;
    description: string;
  };
}

interface UseGetTicketingTicketMembershipsQueryProps {
  ticketId: string;
  enabled?: boolean;
  onSuccess?: (data: TicketMembershipResponse) => void;
  onError?: (error: unknown) => void;
}

const fn = async ({
  ticketId,
  onSuccess,
  onError,
}: UseGetTicketingTicketMembershipsQueryProps) => {
  try {
    const response = await axios.get<TicketMembershipResponse>(
      API_TICKETING_TICKET_MEMBERSHIP(ticketId)
    );

    if (response.data?.error) {
      throw exceptionHandler(response);
    }

    onSuccess?.(response.data);

    return response.data;
  } catch (error) {
    onError?.(error);

    throw error;
  }
};

export const useGetTicketingTicketMembershipsQuery = ({
  ticketId,
  onSuccess,
  onError,
  enabled = true,
}: UseGetTicketingTicketMembershipsQueryProps) =>
  useQuery({
    enabled: Boolean(ticketId) && enabled,
    queryKey: getTicketPermissionKeys(ticketId),
    queryFn: () =>
      fn({
        ticketId,
        onSuccess,
        onError,
      }),
    retry: false,
  });
